module.exports = __webpack_public_path__ + "media/images/sharing/energiefranken-og-fr-c268d9c38b3d103bf6f873be5911adce.png";